// @ts-check
import clsx from 'clsx'
import styles from './ScrollContainer.module.css'

/**
 * @typedef {{
 *  children: import('react').ReactNode,
 *  orientation?: 'horizontal' | 'vertical',
 * }} Props
 */

/** @param {Props} props */
export default function ScrollContainer({ children, orientation = 'horizontal' }) {
  return (
    <div
      className={clsx(styles.scrollContainer, {
        [styles.horizontal]: orientation === 'horizontal' || !orientation,
        [styles.vertical]: orientation === 'vertical',
      })}
    >
      {children}
    </div>
  )
}
